// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__Zv+bQ","carouselImage":"Carousel_carouselImage__1-jqR","active":"Carousel_active__15Pjo","prev":"Carousel_prev__Uaf09","next":"Carousel_next__A0YP7"};